module.exports = __webpack_public_path__ + "media/images/FWD-Banner-09803984de15f0e88051026b48cb6119.png";